export type HighlightsSuccessAction = {type: typeof OFFERING_HIGHLIGHTS_SUCCESS};

export const OFFERING_HIGHLIGHTS_SUCCESS = "OFFERING_HIGHLIGHTS_SUCCESS";
